import React from "react";

interface DividerProps {
  text?: string;
  children?: React.ReactNode;
  className?: string;
}

const Divider: React.FC<DividerProps> = ({ text, children, className }) => {
  const content = text || children;
  if (content) {
    return (
      <div className={`flex items-center gap-3 my-2 ${className || ""}`}>
        <div className="flex-1 h-px bg-[var(--border-subtle)]" />
        <span className="text-[11px] text-[var(--text-tertiary)] uppercase tracking-widest font-medium select-none">
          {content}
        </span>
        <div className="flex-1 h-px bg-[var(--border-subtle)]" />
      </div>
    );
  }

  return <div className={`w-full h-px bg-[var(--border-subtle)] my-2 ${className || ""}`} />;
};

export default Divider;
